import {
	comMapping
} from "@/components/util/Function/comMapping";
export default {
	pagination: {
		pageNum: 1,
		pageSize: 50,
		total: 0,
		paginationkey: 0
	},
	formlist: [{
			prop: "policyTitle",
			label: "标题",
			type: "input",
			width: "220px",
			isnotnull: true
		},
		{
			prop: "isValid",
			label: "是否失效",
			type: "radio",
			isnotnull: true,
			radioval: [{
					label: "是",
					value: "1"
				},
				{
					label: "否",
					value: "2"
				},
				{
					label: "部分",
					value: "3"
				}
			],
		},
		{
			prop: "xianggxz",
			label: "相关税种",
			clearable:true,
			type: "select",
			width: "220px",
			selectval: comMapping.$xgsz
		},
		{
			prop: "fbDanw",
			label: "发文机构",
			type: "input",
			width: "220px"
		},
		{
			prop: "openRule",
			clearable:true,
			label: "开放权限",
			type: "select",
			width: "220px",
			selectval: comMapping.$kfqx,
		},
		{
			prop: "policyNum",
			label: "发文字号",
			type: "input",
			width: "220px",
		},{
			prop: "policyType",
			clearable:true,
			label: "政策类型",
			type: "select",
			width: "220px",
			selectval: comMapping.$sszskzclx,
		},
		{
			prop: "tagIds",
			label: "大类",
			type: "select",
			clearable:true,
			width: "220px",
			slot:true,
		},
		{
			prop: "fabTime",
			label: "发行日期",
			type: "date",
			width: "220px",
			isdate: true,
			valueformat:'yyyy-MM-dd'
		},
		{
			prop: "implementTime",
			label: "施行日期",
			type: "date",
			width: "220px",
			isdate: true,
			valueformat:'yyyy-MM-dd'
		},{
			prop: "zhongycd",
			label: "重要程度",
			type: "select",
			width: "220px",
			clearable:true,
			selectval:[
				{
					value:'1',
					label:'一般'
				},{
					value:'2',
					label:'重要'
				},
			],
			isdate: true,
		},
	],
	headDatatagId:[
		{
			prop: "tagName",
			title: '标题',
			width: 160,
			align: "left",
			custom: true

		},{
			prop: "cz",
			title: '操作',
			width: 160,
			custom: true
		},
	],
	formdata: {
		id: "",
		policyTitle: "",
		isValid: "1",
		policyType: "1",
		fbDanw: "",
		policyNum: "",
		xianggxz: "1",
		fabTime: "",
		implementTime: "",
		originalLink: "",
		policyDesc: "",
		policyFileList: [],
		policyList: [],
		wikiType: ""
	},
	searchlistzc: [
		{
			prop: "policyTitle",
			label: '标题',
			type: "input"
		},
		{
			prop: "policyType",
			label: '政策类型',
			type: "select",
			selectval: comMapping.$sszskzclx,
		},
		{
			prop: "isValid",
			label: '是否失效',
			type: "select",
			selectval: [{
					label: "是",
					value: "1"
				},
				{
					label: "否",
					value: "2"
				},
				{
					label: "部分",
					value: "3"
				}
			],
		},
	],
	headDatazc: [{
			title: "标题",
			prop: "policyTitle",
			width: 160,
			align: "left"
		},
		{
			title: "发文字号",
			prop: "policyNum",
			width: "80",
		},
		{
			title: "相关文档",
			prop: "policyFile",
			width: "80"
		},
		{
			title: "是否失效",
			prop: "isValid",
			width: "80",
			custom: true
		},
		{
			title: "政策类型",
			prop: "policyType",
			width: "80",
			custom: true

		},
		{
			title: "相关税种",
			prop: "xianggxz",
			width: "80"
		},
		{
			title: "发文日期",
			prop: "fabTime",
			width: 160,
			align: "left"
		},
		{
			title: "施行日期",
			prop: "implementTime",
			width: 160,
			align: "left"
		},
		{
			title: "发文机构",
			prop: "fbdanw",
			width: 160,
			align: "left"
		},
	]
}
